import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import Lottie_ from 'Components/UI/Lottie';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  width: 480px;
  padding: ${({ theme: { system } }) => `0px ${system.fds_sys_spacing_S}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Lottie = styled(Lottie_)`
  width: auto;
  height: 50%;
`;

export const ProgressContainer = styled.div`
  width: 100%;
`;
